import store from '@store'

export default {
  // 是否有权限
  hasPermission (value) {
    if (this.superPermission()) {
      return true
    }
    return this.inPermissions(value)
  },
  // 是否拥有超级用户权限
  superPermission () {
    const user = store.getters && store.getters.user
    return user && user.usertype === '1'
  },
  // 是否有财务权限
  financePermission () {
    const user = store.getters && store.getters.user
    return user && ['1', '5'].includes(user.usertype + '')
  },
  // 用户是否拥有该权限
  inPermissions (value) {
    // 存在权限列表
    const permissions = store.getters && store.getters.permissions
    if (!permissions) {
      return false
    }

    // 用户是否拥有该权限
    let hasPermission = false
    if (value) {
      if (Number.isInteger(value)) {
        hasPermission = permissions.includes(value)
      } else if (value && value instanceof Array && value.length > 0) {
        hasPermission = permissions.some(permission => {
          return value.includes(permission)
        })
      } else {
        throw new Error('hasPermission 的 value 值不合法，必须为数字或者数组，数组不能为空')
      }
    }

    return hasPermission
  },
  hasApiPermission (value) {
    if (this.superPermission()) {
      return true
    }
    return this.inApiPermissions(value)
  },
  // 用户是否拥有该API权限
  inApiPermissions (value) {
    // 存在权限列表
    const permissions = store.getters && store.getters.apiPermissions
    if (!permissions) {
      return false
    }

    // 用户是否拥有该权限
    let hasPermission = false
    if (value) {
      if (_.isString(value)) {
        hasPermission = permissions.includes(value)
      } else if (_.isArray(value) && value.length > 0) {
        hasPermission = permissions.some(permission => {
          return value.includes(permission)
        })
      } else {
        throw new Error('hasPermission 的 value 值不合法，必须为字符串或者数组，数组不能为空')
      }
    }

    return hasPermission
  },
  hasCustomer (value) {
    const user = store.getters && store.getters.user
    if (user) {
      // 超管,财务,服务帐号 有全部客户资源
      if (['1', '5', '6'].includes(user.usertype + '')) {
        return true
      }
      if (user.hasOwnProperty('customerIdArr')) {
        return user.customerIdArr.includes(Number(value))
      } else {
        user.customerIdArr = user.customerid.split(',').map(item => parseInt(item.trim(), 10)).filter(item => !isNaN(item))
        return user.customerIdArr.includes(Number(value))
      }
    }
    return false
  },
  sjfmarketname (name, type) {
    if (type * 1 === 23) {
      if (!name) return name

      const parts = name.split('-')

      if (parts.length >= 2) {
        return parts.slice(0, -1).join('-')
      }
    }
    return name
  }
}



// WEBPACK FOOTER //
// ./core/filters/directive.js